import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { MatSidenav } from '@angular/material/sidenav';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';
import * as moment from 'moment';

@Component({
  templateUrl: './authzone.component.html',
  styleUrls: [ './authzone.component.css' ]
})
export class AuthzoneComponent implements OnInit {
  @ViewChild('mainMenu') mainMenu: any;

  public userInfo: any = {};
  public rol: any = 0;

  public toggleMenu() {
    if (this.mainMenu.opened)this.mainMenu.close();
    else this.mainMenu.open();
  }

  constructor(public tokenStorage: TokenStorageService, public router: Router) { }
  ngOnInit() {
    this.userInfo = this.tokenStorage.getUser();
    this.rol = this.tokenStorage.getRol();
  }
}
